module.exports = __webpack_public_path__ + "img/4064007000.7fc49c9b.jpg";